import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/admin/AdminProfileToolbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/DetailToolbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/details/DetailsBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/feed/FeedList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/profile/BadgePillRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/profile/LeaderboardPill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/profile/ProducerDetailsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/profile/ProfileSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/profile/ProfileViewBeacon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/profile/ReviewsTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/profile/TierBadge.tsx");
